// QuickNotificationList2.jsx
import React, { useContext, useEffect, useRef, useState } from "react";
import PlusIcon from "../icons/PlusIcon";
import PlusRound from "../icons/PlusRound";
import actions from "../actions";
import uuid from "react-uuid";
import EmptyIcon1 from "../icons/EmptyIcon1";
import EmptyIcon2 from "../icons/EmptyIcon2";
import styled, { ThemeContext } from "styled-components";
import { Dialog } from "@headlessui/react";
import WithLoader from "./WithLoader";
import appFetch from "../appFetch";
import apiEndpoints from "../apiEndpoints";
import renderComponent from "../renderComponent";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DrillModalDialog from "./DrillModalDialog";
import { appendQueryToUri } from "../util/generalUtil";
import { QuickNotificationReport } from "../constants/variables";
import EfccLogo from "../logos/EfccLogo.png"; // optional, used as fallback for efcc logo

// Import whichever icons module your project uses.
// Some of your files used "../icons/component" while others used "../icons"
import iconsComponent from "../icons/component";
import iconsDefault from "../icons";
import icons from "../icons";

const QuickNotificationCard = styled.div`
  /* background: ${({ theme }) => theme?.colors?.accent}; */
`;

// unified iconMap (kept your mappings)
const iconMap = {
  home: "HomeIcon",
  setup: "SetupIcon",
  transaction: "TransactionIcon",
  approval: "ApprovalIcon",
  memo: "MemoIcon",
  open: "OpenIcon",
  dashboard: "DashboardIcon",
  confirmation: "ConfirmationIcon",
  payrollReports: "PayrollReportsIcon",
  otherReports: "OtherReportsIcon",
  essReports: "EssReportsIcon",
  bioData: "BioDataIcon",
  Online: "OnlineIcon",
  Users: "UsersIcon",
  Retail: "RetailIcon",
  Wallet: "WalletIcon",
  Ussd: "UssdIcon",
  Draws: "DrawsIcon",
  ThirdParty: "ThirdPartyIcon",
  Accuracy: "AccuracyIcon",
  Feeds: "FeedsIcon",
  Whatsapp: "WhatsappIcon",
  Error: "ErrorIcon",
  Calender: "CalenderIcon",
  map: "MapIcon",
  Statistics: "StatisticsIcon",
  OtherReports: "OtherReportsIcon",
  Ticket: "TicketIcon",
  Search: "SearchIcon",
  report: "OtherReportsIcon",
  Forms: "FormsIcon",
  module: "FormsIcon",
  reports: "StatisticsIcon",
  money: "MoneyIcon",
  action: "ActionIcon",
  followup: "FollowUpIcon",
  pending: "PendingIcon",
  qualified: "PassIcon",
  schedule: "ScheduledIcon",
  demo: "DemoIcon",
  proposal: "PlanIcon",
  onboarding: "OnboardIcon",
  crm: "CRMIcon",
  sales: "SalesIcon",
  inventory: "InventoryIcon",
  horizontalbarchart: "HorizontalBarIcon",
  verticalbarchart: "VerticalBarIcon",
  scatterchart: "ScatterIcon",
  layout: "LayoutIcon",
  piechart: "PieIcon",
  linechart: "LineIcon",
  bell: "BellIcon",
  User: "UserIcon",
  Browser: "BrowserIcon",
  All: "AllIcon",
  Pos: "PosIcon",
  Football: "FootballIcon",
  Bingo: "BingoIcon",
  Lottery: "LotteryIcon",
  efcc: EfccLogo,
  "": "setup",
};

function QuickNotificationList2({
  setLoading,
  options = [],
  children,
  onClick,
  filterOption,
  accessOption,
  variant, // new prop: undefined | "3" | "4" (or numeric 3/4)
}) {
  const theme = useContext(ThemeContext);
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const gridRef = useRef(null);
  const cardLength = options?.length ?? 0;

  // pick available icon library

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: cardLength > 3 ? 3 : cardLength,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: cardLength > 3 ? 3 : cardLength,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: cardLength > 3 ? 3 : cardLength,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: cardLength > 1 ? 1 : cardLength,
          dots: true,
        },
      },
    ],
  };

  const showDetail = (item) => {
    setLoading(true);
    let postData = {
      layoutId: item.layoutid,
      targetId: item.targetid,
      target: item.target,
      dateFilter: filterOption,
      accessFilter: accessOption,
    };

    appFetch
      .get(appendQueryToUri(apiEndpoints.menuView, postData))
      .then((res) => {
        const { layoutid, targetid, drillid } = item;
        setModalData({
          ...res,
          layoutid,
          targetid,
          drillid,
          target: QuickNotificationReport,
        });
        setIsOpen(true);
      })
      .catch((e) => console.log(e.message))
      .finally(() => setLoading(false));
  };

  // --- Variant-specific renderers --- //
  const renderDefaultCard = (item) => {
    // original QuickNotificationList2 card
    const { name, value, box_value, icon, box_badge_json } = item;
    const QuickIcon = iconMap[icon];
    const IconComp = icons[QuickIcon];

    return (
      <div>
        <QuickNotificationCard
          onClick={() => showDetail(item)}
          className="shadow-md cursor-pointer relative px-4 rounded-lg h-44 grid content-around mx-2 mb-2 border"
        >
          <span
            style={{
              backgroundColor:
                box_badge_json && box_badge_json?.box_badge_color,
            }}
            className="rounded-tr-lg rounded-bl-lg w-full justify-end absolute top-0 right-0 max-w-min my-1 capitalize text-xs px-2 py-1 origin-center -translate-y-1 text-white truncate"
            dangerouslySetInnerHTML={{
              __html: box_badge_json?.box_badge_top_value,
            }}
          ></span>

          {IconComp ? (
            React.createElement(IconComp, {
              width: 26,
              height: null,
              fill: theme?.colors?.primary,
            })
          ) : (
            <EmptyIcon2
              width={26}
              height={null}
              fill={theme?.colors?.primary}
            />
          )}
          <div className="">
            <span
              className={`font-semibold -pt-4 ${
                box_value && box_value.length > 16 ? "text-lg" : "text-xl"
              } inline-block`}
              dangerouslySetInnerHTML={{
                __html: box_badge_json
                  ? box_badge_json?.box_badge_value
                  : box_value,
              }}
            ></span>
            <h2 className="font-thin text-sm uppercase">{name}</h2>
          </div>
        </QuickNotificationCard>
      </div>
    );
  };

  const renderVariant3Card = (item) => {
    // layout similar to QuickNotificationList3 (icon on right, stacked text left)
    const { name, value, box_value, icon, box_badge_json, description } = item;
    const QuickIcon = iconMap[icon];
    const IconComp = icons[QuickIcon];

    return (
      <div>
        <QuickNotificationCard
          onClick={() => showDetail(item)}
          className="shadow-md cursor-pointer relative px-4 rounded-lg h-44 grid content-around mx-2 mb-2 border"
        >
          <span
            style={{
              backgroundColor:
                box_badge_json && box_badge_json?.box_badge_color,
            }}
            className="rounded-tr-lg rounded-bl-lg w-full justify-end absolute top-0 right-0 max-w-min my-1 capitalize text-xs px-2 py-1 origin-center -translate-y-1 text-white truncate"
            dangerouslySetInnerHTML={{
              __html: box_badge_json?.box_badge_top_value,
            }}
          ></span>

          <div className="flex flex-row items-center">
            <div className="flex-1 space-y-1">
              <h2 className="font-thin text-sm uppercase">{name}</h2>

              <span
                className={`font-medium ${
                  box_value && box_value.length > 16 ? "text-lg" : "text-xl"
                } inline-block`}
                dangerouslySetInnerHTML={{
                  __html: box_badge_json
                    ? box_badge_json?.box_badge_value
                    : box_value,
                }}
              ></span>

              <h2 className="font-thin text-sm capitalize">{description}</h2>
            </div>

            <div className="px-3">
              {IconComp ? (
                React.createElement(IconComp, {
                  width: 54,
                  height: null,
                  fill: theme?.colors?.primary,
                })
              ) : (
                <EmptyIcon2
                  width={54}
                  height={null}
                  fill={theme?.colors?.primary}
                />
              )}
            </div>
          </div>
        </QuickNotificationCard>
      </div>
    );
  };

  const renderVariant4Card = (item) => {
    // layout similar to QuickNotificationList4 (big icon centered, value below)
    const { name, value, box_value, icon, box_badge_json, description, title } = item;
    const QuickIcon = iconMap[icon];
    const IconComp = icons[QuickIcon];

    return (
      <div>
        <QuickNotificationCard
          onClick={() => showDetail(item)}
          className="shadow-md cursor-pointer relative px-4 rounded-lg h-52 grid content-around mx-2 mb-2  border bg-primary"
        >
          <span
            style={{
              backgroundColor:
                box_badge_json && box_badge_json?.box_badge_color,
            }}
            className="rounded-tr-lg rounded-bl-lg w-full justify-end absolute top-0 right-0 max-w-min my-1 capitalize text-xs px-2 py-1 origin-center -translate-y-1 text-white truncate"
            dangerouslySetInnerHTML={{
              __html: box_badge_json?.box_badge_top_value,
            }}
          ></span>

          <div className="flex flex-row -mt-6">
            <div className="flex-1 space-y-1">
              <h2 className="font-thin text-lg uppercase text-white">{name}</h2>

              <h2 className="font-thin text-white text-sm capitalize">
                {title}
              </h2>

              <span
                className={`font-medium text-white ${
                  box_value && box_value.length > 16 ? "text-xl" : "text-4xl"
                } inline-block`}
                dangerouslySetInnerHTML={{
                  __html: box_badge_json
                    ? box_badge_json?.box_badge_value
                    : box_value,
                }}
              ></span>

              <h2 className="font-thin text-white text-sm capitalize">
                {description}
              </h2>
            </div>

            <div className="px-3">
              {
                // special case: if icon is "efcc", use imported EfccLogo image
                icon === "efcc" ? (
                  <div
                    className="rounded-full overflow-hidden flex items-center justify-center shadow"
                    style={{ width: 140, height: 140 }}
                  >
                    <img
                      src={EfccLogo}
                      alt="EFCC logo"
                      className="object-cover w-full h-full bg-red-700"
                    />
                  </div>
                ) : IconComp ? (
                  React.createElement(IconComp, {
                    width: 54,
                    height: null,
                    fill: theme?.colors?.primary,
                  })
                ) : (
                  <EmptyIcon2 width={54} height={null} fill={"#ffffff"} />
                )
              }
            </div>
          </div>
        </QuickNotificationCard>
      </div>
    );
  };

  // pick renderer (unchanged)
  const pickRenderer = (v) => {
    // allow numeric or string variants: 3, "3", "four", "4"
    if (String(v) === "3") return renderVariant3Card;
    if (String(v) === "4") return renderVariant4Card;
    return renderDefaultCard;
  };

  // ...later in the render return:

  return (
    <>
      {isOpen && (
        <DrillModalDialog
          isOpen={isOpen}
          closeModal={() => setIsOpen(false)}
          item={modalData}
          setLoading={setLoading}
          dateFilter={filterOption}
          accessFilter={accessOption}
        />
      )}

      <div className="mb-4">
        <Slider {...settings}>
          {options &&
            options.map((item, idx) => {
              // prefer per-item variant, fall back to prop `variant`
              const itemVariant = item?.variant;
              const rendererForItem = pickRenderer(itemVariant);
              return <div key={idx}>{rendererForItem(item)}</div>;
            })}
        </Slider>
      </div>
    </>
  );
}

export default WithLoader(QuickNotificationList2);
